<div class="modal-wrapper">
  <nav class="main-nav">
    <ul class="main-nav-list">
      <li>
        <button class="main-nav-link-button" (click)="closeModal('hero')">
          Start
        </button>
      </li>
      <li>
        <button
          class="main-nav-link-button"
          (click)="closeModal('dienstleistung')"
        >
          Dienstleistung
        </button>
      </li>
      <li>
        <button class="main-nav-link-button" (click)="closeModal('about-us')">
          Über Uns
        </button>
      </li>
      <li>
        <button class="main-nav-link-button" (click)="closeModal('angebote')">
          Angebote
        </button>
      </li>
      <li>
        <button class="main-nav-link-button" (click)="closeModal('projects')">
          Projekte
        </button>
      </li>
      <li>
        <button
          class="main-nav-link-button"
          (click)="closeModal('testimonials')"
        >
          Referenzen
        </button>
      </li>
      <li>
        <button class="main-nav-link cta-link" (click)="closeModal('cta')">
          Jetzt Starten
        </button>
      </li>
    </ul>
  </nav>
</div>
